import script from "./cjmfs_gk.vue?vue&type=script&setup=true&lang=js"
export * from "./cjmfs_gk.vue?vue&type=script&setup=true&lang=js"

import "./cjmfs_gk.vue?vue&type=style&index=0&id=f2862876&lang=less"

const __exports__ = script;

export default __exports__